import { useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import {
  canEdit,
  canView,
  getAccess,
  pageKeyFromPath,
  type PageAccess,
  type PageKey,
} from '@/utils/pagePermissions'

export function usePageAccess(pageKey?: PageKey) {
  const { user } = useAuth()
  const location = useLocation()
  const resolvedPageKey = pageKey ?? pageKeyFromPath(location.pathname)

  const access: PageAccess | null =
    resolvedPageKey && user ? getAccess(user, resolvedPageKey) : null

  return {
    pageKey: resolvedPageKey,
    access,
    canView: resolvedPageKey ? canView(user, resolvedPageKey) : false,
    canEdit: resolvedPageKey ? canEdit(user, resolvedPageKey) : false,
    isReadOnly: access === 'read',
    isHidden: access === 'hidden' || access === null,
    isAdmin: user?.role === 'admin',
  }
}
